<app-toolbar></app-toolbar>
<app-header [title]="title">
  <markant-button [routerLink]="routes.welcome" [routerLinkActive]="'primary'" class="link" fill="solid" [colorScheme]="pickedUrl('Übersicht')"
    >Übersicht
  </markant-button>
  <markant-button
    [routerLink]="routes.voting"
    *ngIf="showAbstimmung"
    [routerLinkActive]="'primary'"
    class="link"
    fill="solid"
    [colorScheme]="pickedUrl('Abstimmung')"
    >Abstimmung
  </markant-button>
  <markant-button [routerLink]="routes.products" [routerLinkActive]="'primary'" class="link" fill="solid" [colorScheme]="pickedUrl('Start-ups')"
    >Start-ups
  </markant-button>
</app-header>
<div class="hp-dashboard-outlet">
  <router-outlet></router-outlet>
</div>
<freshdesk-support></freshdesk-support>
